export default "__VITE_ASSET__BtwHU92c__"